<form [formGroup]="landServicesEstimateDetailsForm" class="estimateDetailsForm">
  <div class="formDiv" *ngIf="acquisition || disposal">
    <div class="estimateContainer">
      <div class="subHeader">
        <span>Expenditure Type</span>
      </div>

      <!-- Fields Container -->
      <div class="fieldsContainer">
        <!-- Purchase Price -->
        <div class="fieldRow" *ngIf="acquisition">
          <span class="fieldLabel">Purchase Price</span>
          <mat-form-field class="fieldValue">
            <input
              matInput
              formControlName="purchasePrice"
              appCurrencyMask
              appNumbersOnly
              [readonly]="reviewMode"
              [class.disabledField]="reviewMode"
            />
            <span matPrefix>$</span>
          </mat-form-field>
        </div>

        <!-- Sales proceeds -->
        <div class="fieldRow" *ngIf="disposal">
          <span class="fieldLabel">Sales proceeds</span>
          <mat-form-field class="fieldValue">
            <input
              matInput
              formControlName="salesProceeds"
              appCurrencyMask
              appNumbersOnly
              [readonly]="reviewMode"
              [class.disabledField]="reviewMode"
            />
            <span matPrefix>-$</span>
          </mat-form-field>
        </div>

        <!-- Appraisal -->
        <div class="fieldRow">
          <span class="fieldLabel">Appraisal</span>
          <mat-form-field class="fieldValue">
            <input
              matInput
              formControlName="appraisal"
              appCurrencyMask
              appNumbersOnly
              [readonly]="reviewMode"
              [class.disabledField]="reviewMode"
            />
            <span matPrefix>$</span>
          </mat-form-field>
        </div>

        <!-- Survey -->
        <div class="fieldRow">
          <span class="fieldLabel">Survey</span>
          <mat-form-field class="fieldValue">
            <input
              matInput
              formControlName="survey"
              appCurrencyMask
              appNumbersOnly
              [readonly]="reviewMode"
              [class.disabledField]="reviewMode"
            />
            <span matPrefix>$</span>
          </mat-form-field>
        </div>

        <!-- Title -->
        <div class="fieldRow">
          <span class="fieldLabel">Title</span>
          <mat-form-field class="fieldValue">
            <input
              matInput
              formControlName="title"
              appCurrencyMask
              appNumbersOnly
              [readonly]="reviewMode"
              [class.disabledField]="reviewMode"
            />
            <span matPrefix>$</span>
          </mat-form-field>
        </div>

        <!-- Closing Cost -->
        <div class="fieldRow">
          <span class="fieldLabel">Closing Cost</span>
          <mat-form-field class="fieldValue">
            <input
              matInput
              formControlName="closingCost"
              appCurrencyMask
              appNumbersOnly
              [readonly]="reviewMode"
              [class.disabledField]="reviewMode"
            />
            <span matPrefix>$</span>
          </mat-form-field>
        </div>

        <!-- Legal Fees -->
        <div class="fieldRow">
          <span class="fieldLabel">Legal Fees</span>
          <mat-form-field class="fieldValue">
            <input
              matInput
              formControlName="legalFees"
              appCurrencyMask
              appNumbersOnly
              [readonly]="reviewMode"
              [class.disabledField]="reviewMode"
            />
            <span matPrefix>$</span>
          </mat-form-field>
        </div>

        <!-- Broker/Marketing Fees -->
        <div class="fieldRow">
          <span class="fieldLabel">Broker/Marketing Fees</span>
          <mat-form-field class="fieldValue">
            <input
              matInput
              formControlName="brokerMarketingFees"
              appCurrencyMask
              appNumbersOnly
              [readonly]="reviewMode"
              [class.disabledField]="reviewMode"
            />
            <span matPrefix>$</span>
          </mat-form-field>
        </div>

        <!-- Environmental Review -->
        <div class="fieldRow">
          <span class="fieldLabel">Environmental Review</span>
          <mat-form-field class="fieldValue">
            <input
              matInput
              formControlName="environmentalReview"
              appCurrencyMask
              appNumbersOnly
              [readonly]="reviewMode"
              [class.disabledField]="reviewMode"
            />
            <span matPrefix>$</span>
          </mat-form-field>
        </div>

        <!-- Duke Labor -->
        <div class="fieldRow">
          <span class="fieldLabel">Duke Labor</span>
          <mat-form-field class="fieldValue">
            <input
              matInput
              formControlName="dukeLabor"
              appCurrencyMask
              appNumbersOnly
              [readonly]="reviewMode"
              [class.disabledField]="reviewMode"
            />
            <span matPrefix>$</span>
          </mat-form-field>
        </div>

        <!-- Building Demolition -->
        <div class="fieldRow">
          <span class="fieldLabel">Building Demolition</span>
          <mat-form-field class="fieldValue">
            <input
              matInput
              formControlName="buildingDemolition"
              appCurrencyMask
              appNumbersOnly
              [readonly]="reviewMode"
              [class.disabledField]="reviewMode"
            />
            <span matPrefix>$</span>
          </mat-form-field>
        </div>

        <!-- Environmental Clean-up -->
        <div class="fieldRow">
          <span class="fieldLabel">Environmental Clean-up</span>
          <mat-form-field class="fieldValue">
            <input
              matInput
              formControlName="environmentalCleanup"
              appCurrencyMask
              appNumbersOnly
              [readonly]="reviewMode"
              [class.disabledField]="reviewMode"
            />
            <span matPrefix>$</span>
          </mat-form-field>
        </div>

        <!-- Total -->
        <div class="fieldRow">
          <span class="fieldLabel">Total</span>
          <mat-form-field class="fieldValue">
            <input
              matInput
              [value]="
                landServicesEstimateDetailsForm.get('total')?.value
                  | CurrencyUSD : 'USD' : true : false
              "
              name="total"
              readonly
              class="disabledField"
            />
          </mat-form-field>
        </div>
      </div>

      <!-- Additional Fields for Acquisition -->
      <div class="additionalFieldsContainer">
        <!-- First Row: 3 fields -->
        <div class="field-row">
          <div class="fieldGroup">
            <span class="fieldLabel">Expenditure Type</span>
            <mat-form-field class="fieldValue">
              <input
                matInput
                formControlName="expenditureType"
                [readonly]="reviewMode"
                [class.disabledField]="reviewMode"
              />
            </mat-form-field>
          </div>

          <div class="fieldGroup">
            <span class="fieldLabel">Utility Account</span>
            <mat-form-field class="fieldValue">
              <input
                matInput
                formControlName="utilityAccount"
                [readonly]="reviewMode"
                [class.disabledField]="reviewMode"
              />
            </mat-form-field>
          </div>

          <div class="fieldGroup">
            <span class="fieldLabel">Retirement Unit</span>
            <mat-form-field class="fieldValue">
              <input
                matInput
                formControlName="retirementUnit"
                [readonly]="reviewMode"
                [class.disabledField]="reviewMode"
              />
            </mat-form-field>
          </div>
        </div>

        <!-- Second Row: 2 fields -->
        <div class="field-row">
          <div class="fieldGroup">
            <span class="fieldLabel">Charge Type</span>
            <mat-form-field class="fieldValue">
              <input
                matInput
                formControlName="chargeType"
                [readonly]="reviewMode"
                [class.disabledField]="reviewMode"
              />
            </mat-form-field>
          </div>

          <div class="fieldGroup">
            <span class="fieldLabel">Transaction Type</span>
            <mat-form-field class="fieldValue">
              <input
                matInput
                formControlName="transactionType"
                [readonly]="reviewMode"
                [class.disabledField]="reviewMode"
              />
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Summary of Expenditures -->
      <div class="summaryContainer" *ngIf="acquisition || disposal">
        <div class="subHeader">
          <span>Summary of Expenditures</span>
        </div>

        <!-- Capital Group -->
        <div class="fieldsContainer" formGroupName="capital">
          <div class="subHeader">Capital</div>
          
          <div class="fieldRow" *ngIf="acquisition">
            <span class="fieldLabel">Estimate Cost of Request</span>
            <mat-form-field class="fieldValue">
              <input
                matInput
                formControlName="estimateCostOfRequest"
                appCurrencyMask
                appNumbersOnly
                [readonly]="reviewMode"
                [class.disabledField]="reviewMode"
              />
              <span matPrefix>$</span>
            </mat-form-field>
          </div>

          <div class="fieldRow" *ngIf="acquisition">
            <span class="fieldLabel">Previously Approved</span>
            <mat-form-field class="fieldValue">
              <input
                matInput
                formControlName="previouslyApproved"
                appCurrencyMask
                appNumbersOnly
                [readonly]="reviewMode"
                [class.disabledField]="reviewMode"
              />
              <span matPrefix>-$</span>
            </mat-form-field>
          </div>

          <div class="fieldRow" *ngIf="acquisition">
            <span class="fieldLabel">Subtotal Project Cost</span>
            <mat-form-field class="fieldValue">
              <input
                matInput
                formControlName="subtotalProjectCost"
                appCurrencyMask
                appNumbersOnly
                [readonly]="reviewMode"
                [class.disabledField]="reviewMode"
              />
              <span matPrefix>$</span>
            </mat-form-field>
          </div>

          <div class="fieldRow" *ngIf="acquisition && region !== 'DE Florida'">
            <span class="fieldLabel">AFUDC Percentage</span>
            <mat-form-field class="fieldValue">
              <input
                matInput
                formControlName="afudcPercentage"
                readonly
                class="disabledField"
              />
              <span matSuffix>%</span>
            </mat-form-field>
          </div>

          <div class="fieldRow" *ngIf="acquisition">
            <span class="fieldLabel">Estimated AFUDC of Project</span>
            <mat-form-field class="fieldValue">
              <input
                matInput
                [value]="
                  landServicesEstimateDetailsForm.get('capital.estimatedAfudcOfProject')?.value
                    | CurrencyUSD : 'USD' : true : false
                "
                name="capitalEstimatedAfudc"
                readonly
                class="disabledField"
              />
            </mat-form-field>
          </div>

          <div class="fieldRow">
            <span class="fieldLabel">Total</span>
            <mat-form-field class="fieldValue">
              <input
                matInput
                [value]="
                  landServicesEstimateDetailsForm.get('capital.total')?.value
                    | CurrencyUSD : 'USD' : true : false
                "
                name="capitalTotal"
                readonly
                class="disabledField"
              />
            </mat-form-field>
          </div>
        </div>

        <!-- OM Group -->
        <div class="fieldsContainer" formGroupName="om">
          <div class="subHeader">OM</div>
          
          <div class="fieldRow" *ngIf="acquisition">
            <span class="fieldLabel">Estimate Cost of Request</span>
            <mat-form-field class="fieldValue">
              <input
                matInput
                formControlName="estimateCostOfRequest"
                appCurrencyMask
                appNumbersOnly
                [readonly]="reviewMode"
                [class.disabledField]="reviewMode"
              />
              <span matPrefix>$</span>
            </mat-form-field>
          </div>

          <div class="fieldRow" *ngIf="acquisition">
            <span class="fieldLabel">Previously Approved</span>
            <mat-form-field class="fieldValue">
              <input
                matInput
                formControlName="previouslyApproved"
                appCurrencyMask
                appNumbersOnly
                [readonly]="reviewMode"
                [class.disabledField]="reviewMode"
              />
              <span matPrefix>-$</span>
            </mat-form-field>
          </div>

          <div class="fieldRow">
            <span class="fieldLabel">Total</span>
            <mat-form-field class="fieldValue">
              <input
                matInput
                [value]="
                  landServicesEstimateDetailsForm.get('om.total')?.value
                    | CurrencyUSD : 'USD' : true : false
                "
                name="omTotal"
                readonly
                class="disabledField"
              />
            </mat-form-field>
          </div>
        </div>

        <!-- Total Project Cost -->
        <div class="fieldsContainer">
          <div class="fieldRow">
            <span class="fieldLabel">Total Project Cost</span>
            <mat-form-field class="fieldValue">
              <input
                matInput
                [value]="
                  landServicesEstimateDetailsForm.get('totalProjectCost')?.value
                    | CurrencyUSD : 'USD' : true : false
                "
                name="totalProjectCost"
                readonly
                class="disabledField"
              />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
